import React, { useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import config from "./../config";
import theme from "./../theme";

const useStyles = makeStyles((theme) => ({
  logo: {
    transition: "0.4s all ease-in",
    position: "relative",
    overflow: "hidden",
    //todo improve change
    top: ({ change }) => change ? "0%" : "0%"
  }
}));

export default function LogoIcon({ darkMode , currentAsset, className = "", ...rest }) {
  const srcRef = useRef();
  const clientSrc = darkMode ? config.LOGO_DARK : config.LOGO_LIGHT;
  const src = currentAsset
    ? (darkMode ? currentAsset.logo_dark_url : currentAsset.logo_light_url)
    : clientSrc
  const classes = useStyles({
    ...theme,
    change: srcRef.current !== src
  });
  
  useEffect(() => {
    srcRef.current = src
  }, [src]);

  const css =  [className, classes.logo].join(" ");

  return (
    <img 
      src={src}
      className={css}
      {...rest}
    />
  );
}